import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {Grid} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";

export default function DropdownLanguage() {
    const {i18n} = useTranslation();
    const theme = useTheme();
    const [language, setLanguage] = useState(i18n.language);
    const [open, setOpen] = useState(false);

    // get i18n resource object with all languages
    const languageList = i18n.options.resources;

    const handleLanguageChange = (event) => {
        const lang = event.target.value;
        setLanguage(lang);
        i18n.changeLanguage(lang);
        // set localStorage when language is changed
        window.localStorage.setItem("languageSet", lang);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <Grid
            id="language-selector-container"
            container
            direction="row"
            justifyContent="space-around"
            sx={{width: "200px", justifyContent: "flex-start", pL: theme.spacing(2)}}
        >
            <FormControl variant="standard">

                <Select
                    id="language"
                    value={language}
                    open={open}
                    onClose={handleClose}
                    variant="outlined"
                    onOpen={handleOpen}
                    onChange={handleLanguageChange}
                     sx={{width: "150px"}}
                >
                    {Object.keys(languageList).map((l) => (
                        <MenuItem key={l} value={l}>
                            {languageList[l].name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
    );
}
